import ManageShoppingList from './ManageShoppingList';

export default ManageShoppingList;
